var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAllowCall)?_c('v-switch',{attrs:{"disabled":_vm.isChanging,"label":"Прием звонков","hide-details":""},on:{"click":function($event){return _vm.changeCallState()}},model:{value:(_vm.queueStatusModel),callback:function ($$v) {_vm.queueStatusModel=$$v},expression:"queueStatusModel"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }